const { default: styled } = require('styled-components');

const RefreshModalContantWrapper = styled.div`
    width: 100%;
    color: black;

    .title {
        margin: 0px;
        font-weight: 700;
        text-transform: none;
    }

    .content {
        margin: 4px 0 0 0;
        line-height: 24px;
        text-align: justify;
    }

    .refreshButton {
        width: 100%;
        margin-top: 10px;
    }
`;

export default RefreshModalContantWrapper;
